import { render, staticRenderFns } from "./BTextForm.vue?vue&type=template&id=dced7698&"
import script from "./BTextForm.vue?vue&type=script&lang=js&"
export * from "./BTextForm.vue?vue&type=script&lang=js&"
import style0 from "./BTextForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports